let thisData = {};
let terms = [];
let page = 1;

/**
 * Set active parameters
 *
 * @return array
 */
function setParameters(data) {
  let forParams = {};
  if (terms) {
    forParams.cat = data.terms;
  }

  if (page !== 1) {
    forParams.p = data.page;
  }

  var parameters = $.param(forParams);
  return parameters;
}

/**
 * Get active terms
 *
 * @return array
 */
function getActiveTerms() {
  $('.filter__item.active').each(function () {
    terms = $(this).data('term');
  });

  return terms;
}

/**
 * The AJAX function that load posts
 */
function ajaxLoadPosts(thisData, emptyContainer) {
  var params = setParameters(thisData);
  window.history.pushState('', '?', params);

  $.ajax({
    url: window.ajaxvars.ajax_url,
    type: 'post',
    data: thisData,
    beforeSend: () => {
      if (emptyContainer) {
        $('.posts-container > *').remove();
      }
      $('.posts-container').append(
        '<div class="posts-container__loader"></div>'
      );
    },
    success: (data) => {
      $('.posts-container__loader').remove();
      if (!data || data.trim() === '') {
        $('.posts-container').append(
          '<div class="no-posts">Geen berichten gevonden.</div>'
        );
      } else {
        $('.posts-container').append(data);
      }
      $('html, body').animate({ scrollTop: 0 });
    },
  });
}

/**
 * Get Data according to post type
 */
function getData(terms) {
  thisData = {
    action: 'blackdesk_load_posts',
    page: page,
    terms: terms,
  };

  return thisData;
}

/**
 * Handle filter click
 */
$(document).on('click', '.filter__item', function (event) {
  event.preventDefault();
  $('.filter__item')
    .not($(this))
    .each(function () {
      $(this).removeClass('active');
    });
  $(this).toggleClass('active');

  page = 1;
  thisData = getData($(this).data('term'));
  ajaxLoadPosts(thisData, true);
});

/**
 * Pagination click handles
 *
 * @param event
 * @param int nextpage
 */
function pagination(event, nextpage) {
  event.preventDefault();

  page = nextpage;
  terms = getActiveTerms();
  thisData = getData(terms);

  ajaxLoadPosts(thisData, nextpage);
}

$(document).on('click', '.page-numbers', function (event) {
  pagination(event, $(this).html());
});

$(document).on('click', '.archive__pagination__link', function (event) {
  pagination(event, $(this).data('page'));
});

// get parameter of current url
function getUrlParameter(name) {
  name = name.replace(/[[]/, '[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// get term id from url and trigger a click on filter item
$(document).ready(function () {
  var cat = getUrlParameter('term');
  if (cat) {
    $('.filter-item[data-term="' + cat + '"]').trigger('click');
  }
});
